var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.485,
    height: 13,
    viewBox: "0 0 14.485 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14408",
    "data-name": "Group 14408",
    transform: "translate(126.335 -44.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14409",
    "data-name": "Group 14409",
    transform: "translate(-125.982 45.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11307",
    "data-name": "Path 11307",
    d: "M425.848,200.013l-1.117,1.117-1.117-1.117",
    transform: "translate(-412.07 -194.572)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11308",
    "data-name": "Path 11308",
    d: "M2.588,201.131l-1.117-1.117L.354,201.131",
    transform: "translate(-0.354 -194.572)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11309",
    "data-name": "Path 11309",
    d: "M41.317,200.013v.744a5.8,5.8,0,0,0,5.669,5.814h.1a6,6,0,0,0,5.772-4.355",
    transform: "translate(-40.2 -194.572)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11310",
    "data-name": "Path 11310",
    d: "M41.317,4.855A6,6,0,0,1,47.089.5h.1a5.8,5.8,0,0,1,5.669,5.814v.744",
    transform: "translate(-40.2 -0.5)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.2ed1ea1be265d090642cdb6bd8362533.svg";
export { ForwardRef as ReactComponent };